// constants & support
import { Utils } from './utils';
import { Verbs } from './constants/verbs';
import { IXapiSvc } from './support/svc';

// classes
import { About } from './classes/about';
import { Activity } from './classes/activity';
import { Agent } from './classes/agent';
import { Context } from './classes/context';
import { Group } from './classes/group';
import { Result } from './classes/result';
import { Score } from './classes/score';
import { Statement } from './classes/statement';
import { Verb } from './classes/verb';
//
import { svc } from './support/svc';

export class XAPI {
	public static Verbs = Verbs;
	public static getUUID = Utils.getUUID;
	public static calculateISO8601Duration = Utils.calculateISO8601Duration;
	public static getISODateString = Utils.getISODateString;
	//
	public static About = About;
	public static Activity = Activity;
	public static Agent = Agent;
	public static Context = Context;
	public static Group = Group;
	public static Result = Result;
	public static Score = Score;
	public static Statement = Statement;
	public static Verb = Verb;
	//
	public static svc: IXapiSvc = svc;
}
